export default __webpack_public_path__ + "static/media/1299.493334e8.png";